/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MessagingChannelUnlinkResponse
 */
export interface MessagingChannelUnlinkResponse {
  /**
   *
   * @type {string}
   * @memberof MessagingChannelUnlinkResponse
   */
  channelId: string;
  /**
   *
   * @type {Date}
   * @memberof MessagingChannelUnlinkResponse
   */
  unlinkedAt: Date;
}

/**
 * Check if a given object implements the MessagingChannelUnlinkResponse interface.
 */
export function instanceOfMessagingChannelUnlinkResponse(
  value: object
): value is MessagingChannelUnlinkResponse {
  if (!("channelId" in value) || value["channelId"] === undefined) return false;
  if (!("unlinkedAt" in value) || value["unlinkedAt"] === undefined)
    return false;
  return true;
}

export function MessagingChannelUnlinkResponseFromJSON(
  json: any
): MessagingChannelUnlinkResponse {
  return MessagingChannelUnlinkResponseFromJSONTyped(json, false);
}

export function MessagingChannelUnlinkResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MessagingChannelUnlinkResponse {
  if (json == null) {
    return json;
  }
  return {
    channelId: json["channel_id"],
    unlinkedAt: new Date(json["unlinked_at"]),
  };
}

export function MessagingChannelUnlinkResponseToJSON(
  json: any
): MessagingChannelUnlinkResponse {
  return MessagingChannelUnlinkResponseToJSONTyped(json, false);
}

export function MessagingChannelUnlinkResponseToJSONTyped(
  value?: MessagingChannelUnlinkResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    channel_id: value["channelId"],
    unlinked_at: value["unlinkedAt"].toISOString(),
  };
}
